import produce from "immer"
import { DESC, CREATED_AT, PAYMENT_OTHER } from "const"
import { MtAccountPackage } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initPackageUsage: types.PackageUsage = {
    maxCalculations: 0,
    usedCalculations: 0,
}

export const initAccountPackage: MtAccountPackage = {
    id: null,
    accountId: null,
    packageId: null,
    dateStart: null,
    dateEnd: null,
    paymentOption: PAYMENT_OTHER,
    stripePaymentId: null,
    usedSilCalculations: 0,
    additionalSilCalculations: 0,
}

const initAccountPackageState: types.AccountPackageState = {
    accountPackageList: null,
    accountPackageEdit: initAccountPackage,

    packageAllowed: [],

    sortColumn: CREATED_AT,
    sortOrder: DESC,

    reloadList: true,
    reloadEdit: true,
}

const accountPackageReducer = produce((
    draft: types.AccountPackageState = initAccountPackageState,
    action: ActionTypes = null,
): types.AccountPackageState => {
    switch (action.type) {
        case types.ACCOUNT_PACKAGE_LIST:
            draft.accountPackageList = action.accountPackageList
            return draft

        case types.ACCOUNT_PACKAGE_EDIT:
            draft.accountPackageEdit = action.accountPackage
            return draft

        case types.ACCOUNT_PACKAGE_ALLOWED:
            draft.packageAllowed = action.packageAllowed
            return draft

        case types.ACCOUNT_PACKAGE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.ACCOUNT_PACKAGE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.ACCOUNT_PACKAGE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default accountPackageReducer
